// src/features/groups/components/GroupHeader.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  ChevronLeft,
  Users,
  Bot,
  BotOff
} from 'lucide-react';
import { AffinRecordsIcon } from '../../../components/icons';
import { Avatar, AVATAR_VARIANTS } from '../../../components/avatars';
import './GroupHeader.css';

const GroupHeader = ({ 
  group, 
  onBack,
  onOpenSettings,
  onToggleBotResponses,
  botResponsesEnabled = true,
  onShowAllPosts
}) => {
  const { t } = useTranslation();

  return (
    <header className="group-header">
      <div className="group-header-container">
        <div className="group-header-left">
          <button
            onClick={onBack}
            className="back-button"
            aria-label={t('common.back')}
          >
            <ChevronLeft size={30} />
          </button>

          <button
            onClick={onOpenSettings}
            className="group-info"
            aria-label={t('groups.view_group_info')}
            disabled={!onOpenSettings}
          >
            <Avatar
              variant={AVATAR_VARIANTS.GROUP}
              name={group?.name || ''}
              src={group?.icon}
              size="md"
              className="group-icon"
              alt={group?.name || t('common.loading')}
              textColor="var(--background-elevated)"
            />

            <div className="group-details">
              <h2 className="group-name">{group?.name || t('common.loading')}</h2>
              {group?.memberCount !== undefined && (
                <div className="group-meta">
                  <Users size={16} />
                  <span>{t('groups.member_count', { count: group.memberCount })}</span>
                </div>
              )}
            </div>
          </button>
        </div>

        <div className="group-header-right">
          <button
            onClick={onShowAllPosts}
            className="group-records-button"
            aria-label={t('groups.view_group_records')}
            title={t('groups.view_group_records')}
          >
            <AffinRecordsIcon size={26} className="records-icon" />
          </button>
          
          <button
            onClick={onToggleBotResponses}
            className="bot-toggle-button"
            aria-label={botResponsesEnabled ? t('groups.disable_bot') : t('groups.enable_bot')}
            title={botResponsesEnabled ? t('groups.disable_bot') : t('groups.enable_bot')}
            disabled={!onToggleBotResponses}
          >
            {botResponsesEnabled ? (
              <Bot size={29} className="bot-icon enabled" />
            ) : (
              <BotOff size={29} className="bot-icon disabled" />
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default GroupHeader;
